export const NONE_SELECTED = '-1'
